import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const FastAndResponsiveEcommerceWebsitesInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Fast and Responsive E-commerce Websites in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Speed Meets Flexibility</Subheading>}
        heading={
          <Heading>
            Fast and <span tw="text-primary-500">Responsive E-commerce</span>{" "}
            Websites in Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we create fast and responsive e-commerce websites
            in **Dubai**, delivering lightning-fast load times and seamless
            experiences across all devices. Boost your sales with our
            high-performance online stores.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1580894908361-967195033215?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1601972599748-19fe5a7e756f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Launch Your Fast Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="High-Speed E-commerce in Dubai"
        description="We build stores that load fast and adapt perfectly."
        cards={[
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Blazing Fast Load Times",
            description: "Optimized for speed to keep customers engaged.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Fully Responsive",
            description: "Perfect on desktops, tablets, and phones.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Conversion Optimized",
            description: "Fast sites designed to drive sales.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Performance Tuning",
            description: "Fine-tuned for top efficiency.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure & Reliable",
            description: "Speed without compromising safety.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Experts",
            description: "Dubai’s choice for fast e-commerce.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Speed & Responsiveness Process"
        description={
          <Description>
            We craft fast and responsive stores with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Define performance and device goals.</li>
              <li>Design: Create lightweight, adaptive layouts.</li>
              <li>Development: Optimize code and assets for speed.</li>
              <li>Testing: Ensure quick load times and responsiveness.</li>
              <li>Launch: Deliver a high-speed, versatile store.</li>
              <li>Support: Maintain peak performance over time.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1534120247760-c44c3e4a62f1?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1593642702821-c8da6771f0c6?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1620714223084-8fcacc6dfd8d?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Fast & Responsive Wins in Dubai"
        description="Our stores deliver results that matter."
        cards={[
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Speed Boost",
            description: "Reduced load time by 50% for a client.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Surge",
            description: "Responsive design lifted sales by 140%.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Approval",
            description: "96% satisfaction with performance.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Speed?</Subheading>}
        heading="Fast and Responsive E-commerce Websites in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for fast and responsive e-commerce
            websites in Dubai. Get a high-performance store that shines on every
            device—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1564069114553-7215e1ff1890?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1574717024453-354056adc482?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
